import axios from 'axios'
import cek401 from './cek401'

export const deleteMixins = {
    mixins: [cek401],
    methods: {
        /* 
        fungsi yang digunakan untuk hapus data pada table untuk pemakaian secara global. 
        */
        async delete (id, path) {
            try {
                await axios.delete(path + id )
                this.$swal({
                    title: "Data Berhasil Dihapus!",
                    icon: "success",
                    type: "success",
                    showCloseButton: true,
                    showConfirmButton: false,
                    timer: 5000,
                })
                this.reload()
            } catch (error) {
                console.log(error)
                if (error.response.status == 401) {
                    // cek auth mixins
                    this.cekAuth()
                }
            }
        }
    }
}

export default deleteMixins